import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { IState } from '../../../../store/types'
import { IShowStateProps, IShowDispatchProps } from './types'
import { fetchHospitals } from '../../../../store/hospitals/actions'
import { fetchPlans } from '../../../../store/plans/actions'
import { fetchInstallations } from '../../../../store/installations/actions'
import { Show } from './Show'
import { fetchSubscriptions } from '../../../../store/subscriptions/actions'

const mapStateToProps = (state: IState): IShowStateProps => {
  return {
    installations: state.installations,
    hospitals: state.hospitals,
    subscriptions: state.subscriptions,
    plans: state.plans,
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): IShowDispatchProps => {
  return {
    fetchHospitals: () => {
      return dispatch(fetchHospitals())
    },

    fetchSubscriptions: (hospitalId: string) => {
      return dispatch(fetchSubscriptions(hospitalId))
    },

    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },

    fetchPlans: () => {
      return dispatch(fetchPlans())
    },
  }
}

const ShowContainer = connect(mapStateToProps, mapDispatchToProps)(Show)

export {
  ShowContainer
}
